import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/lib/utils";
import { Clock, Home, MapPin, User } from "lucide-react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ReviewList(t0) {
  const $ = _c(12);
  const {
    items,
    selection,
    onSelect
  } = t0;
  if (items.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = /*#__PURE__*/_jsx("div", {
        className: "flex h-full items-center justify-center p-8 text-sm text-gray-500",
        children: "Inget att granska"
      });
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== items || $[2] !== onSelect || $[3] !== selection?.id || $[4] !== selection?.type) {
    let t2;
    if ($[6] !== onSelect || $[7] !== selection?.id || $[8] !== selection?.type) {
      t2 = item => {
        const isSelected = selection?.type === item.type && selection?.id === item.id;
        const Icon = item.type === "place" ? Home : MapPin;
        return /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsxs("button", {
            type: "button",
            onClick: () => onSelect({
              type: item.type,
              id: item.id
            }),
            className: cn("flex w-full flex-col gap-1 px-4 py-3 text-left transition-colors", "hover:bg-gray-50", isSelected && "bg-brand/5 border-l-4 border-l-brand pl-3"),
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex items-center gap-2",
              children: [/*#__PURE__*/_jsx(Icon, {
                className: "h-3.5 w-3.5 shrink-0 text-gray-400"
              }), /*#__PURE__*/_jsx("span", {
                className: "truncate text-sm font-semibold text-gray-900",
                children: item.title
              }), item.needsRecheck && /*#__PURE__*/_jsx("span", {
                className: "rounded-full bg-amber-100 px-1.5 py-0.5 text-[10px] font-medium text-amber-700",
                children: "Kolla igen"
              })]
            }), item.subtitle && /*#__PURE__*/_jsx("p", {
              className: "truncate text-xs text-gray-500",
              children: item.subtitle
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-gray-500",
              children: [item.tags.map(_temp), item.creatorName && /*#__PURE__*/_jsxs("span", {
                className: "flex items-center gap-1",
                children: [/*#__PURE__*/_jsx(User, {
                  className: "h-3 w-3"
                }), item.creatorName]
              }), /*#__PURE__*/_jsxs("span", {
                className: "flex items-center gap-1",
                children: [/*#__PURE__*/_jsx(Clock, {
                  className: "h-3 w-3"
                }), item.createdAt.toLocaleDateString("sv-SE")]
              })]
            })]
          })
        }, `${item.type}:${item.id}`);
      };
      $[6] = onSelect;
      $[7] = selection?.id;
      $[8] = selection?.type;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    t1 = items.map(t2);
    $[1] = items;
    $[2] = onSelect;
    $[3] = selection?.id;
    $[4] = selection?.type;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[10] !== t1) {
    t2 = /*#__PURE__*/_jsx("ul", {
      className: "divide-y",
      children: t1
    });
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
function _temp(tag) {
  return /*#__PURE__*/_jsx("span", {
    className: "rounded bg-gray-100 px-1.5 py-0.5 font-medium text-gray-600",
    children: tag
  }, tag);
}